import {takeEvery} from 'redux-saga/effects';
import {UserActionTypes} from "@fkhplus/common/src/modules/user/actions";
import {IFluxStandardAction} from '@fkhplus/common/src/modules/interfaces';
import {ISetUserResponse} from '@fkhplus/common/src/modules/user/interfaces';

function* userFetch(action: IFluxStandardAction<ISetUserResponse>): Generator {
    //TODO: Ashitha | 14-Feb-22 | Will be either removed or use logger
}

function* watchUserSagas(): Generator {
    yield takeEvery(UserActionTypes.IS_LOGGED_IN, userFetch)
}

export default watchUserSagas;
